import { Check } from "lucide-react";

export const inputCls = "w-full bg-white/5 border border-white/10 rounded-2xl px-5 py-4 text-white placeholder-white/30 outline-none focus:border-[#2563EB] transition-colors";
export const labelCls = "text-xs font-bold uppercase tracking-wider text-white/40";

export const STEPS = ["Program", "Participant", "Review", "Agreements", "Payment"];

export function StepIndicator({ step }) {
  return (
    <ol data-testid="reg-step-indicator" className="mt-6 grid grid-cols-5 gap-1.5">
      {STEPS.map((s, i) => {
        const n = i + 1;
        const state = n < step ? "done" : n === step ? "current" : "todo";
        return (
          <li key={s} data-testid={`reg-step-${n}`} data-state={state} className="flex flex-col gap-1.5">
            <span className={`h-1 rounded-full transition-colors duration-300 ${state === "todo" ? "bg-white/10" : "bg-[#2563EB]"}`} />
            <span className={`text-[10px] sm:text-[11px] font-bold uppercase tracking-wider truncate ${state === "current" ? "text-white" : "text-white/35"}`}>{n}<span className={state === "current" ? "" : "hidden sm:inline"}>. {s}</span></span>
          </li>
        );
      })}
    </ol>
  );
}

export function FieldError({ msg }) {
  return msg ? <span className="mt-1 block text-xs font-semibold text-red-400">{msg}</span> : null;
}

export function CheckRow({ testid, checked, onChange, children, error, ariaLabel, dataAttrs = {} }) {
  return (
    <div>
      <label className={`flex items-start gap-3 cursor-pointer rounded-2xl border-2 px-4 py-3.5 transition-colors ${checked ? "border-[#2563EB] bg-[#2563EB]/10" : error ? "border-red-400/50" : "border-white/10 hover:border-white/25"}`}>
        <span className="relative mt-0.5 shrink-0">
          <input data-testid={testid} type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="peer sr-only" aria-label={ariaLabel} {...dataAttrs} />
          <span className={`inline-flex items-center justify-center w-5 h-5 rounded-md border transition-colors peer-focus-visible:ring-2 peer-focus-visible:ring-[#2563EB] ${checked ? "bg-[#2563EB] border-[#2563EB]" : "border-white/40"}`}>{checked && <Check size={13} strokeWidth={3} className="text-white" />}</span>
        </span>
        <span className="text-sm font-medium text-white/75 leading-relaxed">{children}</span>
      </label>
      <FieldError msg={error} />
    </div>
  );
}

export function calcAge(dob) {
  if (!dob) return null;
  const [y, mo, da] = String(dob).split("-").map(Number);
  const d = new Date(y, (mo || 1) - 1, da || 1);
  if (isNaN(d.getTime())) return null;
  const t = new Date();
  let a = t.getFullYear() - d.getFullYear();
  const m = t.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && t.getDate() < d.getDate())) a -= 1;
  return a;
}

export const money = (v) => `$${Number(v || 0).toFixed(2).replace(/\.00$/, "")}`;
